module.exports = __webpack_public_path__ + "static/img/industryNews_banner.c91b0977.png";